<div class="login-block">
  <div class="container">
    <div class="card flex-grow-1 my-2">
      <div class="card-body">
        <div class="logo">
          <img src="/assets/tyre-buzzar-logo.png" alt="Tyre Buzzar Logo" width="100" />
        </div>
        <form (ngSubmit)="onLogin()" name="loginForm" [formGroup]="loginForm">
          <div class="form-group" [class.d-none]="otpSent">
            <label for="phone">Phone number<span class="text-danger">*</span></label>
            <div class="input-group">
              <span class="input-group-text default-form-group-border" style="background-color: #fff; font-size: 1rem; border-right: none;">+91</span>
              <input formControlName="username" id="phone" name="phone" autocomplete="tel" maxlength="10"
                class="form-control form-control-lg default-form-group-border" placeholder="Phone number"
                required type="tel" (input)="onInput($event)" (keydown.enter)="$event.preventDefault(); sendOtp()"
                appAllowOnlyNumber [decimalPlaces]="0" [allowLeadingZero]="true" style="border-left: none; padding-left: 0.25rem;" />
            </div>
            @if (loginForm.get('username')?.invalid && (loginForm.get('username')?.dirty || loginForm.get('username')?.touched)) {
              <div class="errorText mt-1">
                @if (loginForm.get('username')?.errors?.['pattern']) {
                  <small class="text-danger">Please Enter a Valid Mobile Number</small>
                }
                @if (loginForm.get('username')?.errors?.['required']) {
                  <small class="text-danger">Mobile Number is Required</small>
                }
              </div>
            }
          </div>

          @if (otpSent) {
            <div class="otp-sent-banner mb-2">
              <div>
                <small class="text-muted d-block" style="font-size: 0.8rem;">OTP sent to</small>
                <span class="phone-display">+91 {{ loginForm.get('username')?.value }}</span>
              </div>
              <button type="button" class="edit-number-btn" (click)="goBack()" title="Change number">
                <fa-icon [icon]="faPen"></fa-icon>
              </button>
            </div>

            <div class="form-group">
              <label for="otp">OTP<span class="text-danger">*</span></label>
              <input #otpInput formControlName="otp" id="otp"
                class="form-control form-control-lg default-form-group-border" type="number"
                placeholder="Enter OTP" required (keydown.enter)="$event.preventDefault(); onLogin()" (input)="onOtpInput($event)" (keydown.arrowup)="$event.preventDefault()" (keydown.arrowdown)="$event.preventDefault()" />
              @if (loginForm.get('otp')?.invalid && (loginForm.get('otp')?.dirty || loginForm.get('otp')?.touched)) {
                <div class="errorText">
                  @if (loginForm.get('otp')?.errors?.['required']) {
                    <div>
                      <small class="text-danger">OTP is Required</small>
                    </div>
                  }
                  @if (loginForm.get('otp')?.errors?.['pattern']) {
                    <div>
                      <small class="text-danger">OTP must be exactly 6 digits</small>
                    </div>
                  }
                </div>
              }
              <div class="mt-2 text-end">
                @if (resendCountdown > 0) {
                  <small class="text-muted">Resend OTP in {{ resendCountdown }}s</small>
                } @else {
                  <a href="javascript:void(0)" class="text-link" (click)="sendOtp()">Resend OTP</a>
                }
              </div>
            </div>
          }
          @if (errorMessage) {
            <div class="mb-2 text-center">
              <small class="text-danger">{{ errorMessage }}</small>
            </div>
          }
          @if (!otpSent) {
            <button type="button" class="btn app-btn-primary w-100" [disabled]="loginForm.get('username')?.invalid || isLoading" (click)="sendOtp()">
              Login with OTP
              @if (isLoading) {
                <output class="spinner-border spinner-border-sm ms-1" aria-hidden="true"></output>
              }
            </button>
          } @else {
            <button type="submit" class="btn app-btn-primary w-100" [disabled]="loginForm.invalid || isLoading">
              Login
              @if (isLoading) {
                <output class="spinner-border spinner-border-sm ms-1" aria-hidden="true"></output>
              }
            </button>
          }
        </form>
        <div class="mt-2 text-danger">
          <small class="text-danger">{{errorLogin}}</small>
        </div>
        <div class="mt-2 p-3 text-center">
          <div class="reg-text text-center">
            Not Registered? <a [routerLink]="['/register']" class="text-link">Register Now</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>